import { OccupationItemsWithFormattedDates } from 'pages/candidateOffer/types';
import React from 'react';
import styled from 'styled-components';

import ShiftScheduleListItem from './ShiftScheduleListItem';
import ShiftsListHead from './ShiftsListHead';
import { OfferItemsTranslationSection } from './types';

interface ShiftsScheduleListProps {
    items: OccupationItemsWithFormattedDates[];
    onSelectAllClick: () => void;
    onSelect: (itemId: string) => void;
    selectedIds: string[];
    translationSection: OfferItemsTranslationSection;
}

export default function OfferItemScheduleList({
    items,
    onSelectAllClick,
    onSelect,
    selectedIds,
    translationSection
}: ShiftsScheduleListProps) {
    return (
        <Root>
            <ShiftsListHead onSelectAllClick={ onSelectAllClick }
                itemsSelected={ selectedIds.length }
                itemsTotal={ items.length }
                translationSection={ translationSection }
            />

            { items.map((item) => {
                return (
                    <ShiftScheduleListItem key={ item.id }
                        { ...item }
                        checked={ selectedIds.includes(item.id) }
                        onCheckboxClick={ () => onSelect(item.id) }
                    />
                );
            } ) }
        </Root>
    );
}

const Root = styled.div`
    display: flex;
    flex-direction: column;
`;
